<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <!--<img src="@/assets/img/logo_white.png" alt="logo图">-->
    </div>
    <p class="title">嘉立讯官方网站</p>
    <p class="address_tel_fax">
      <span>地址：江苏省宿迁市沭阳县帝景华府10幢1220室</span>
      <span>邮箱：jialixundz@163.com</span>
    </p>
    <p class="email_wx">
      <!--<span>公司微信号：ilyk_gg</span>-->
    </p>
    <div class="copy">
      <p>
        <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #d3d3d3">苏ICP备2024099818号-1</a>
      </p>
      Copyright &copy; 2023 - 2024 沭阳嘉立讯电子设备经营部
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 30px 0 20px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 20px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue